import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CardExporting from '../../components/Card/CardExporting';

/**
 * Componente contextual de CardExporting, acoplado ao contexto
 * e regras de negocio do sistema
 */
const propTypes = {
  types: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  onCancel: PropTypes.func,
  onFailure: PropTypes.func,
  title: PropTypes.string,
};

const defaultProps = {
  title: 'Exportar...',
  types: [],
  onCancel: null,
  onFailure: null,
};

function ContextualPopupExporting(props) {
  // state from props
  const {
    title,
    types,
    onTypeChange,
    onCancel,
    theme,
    selectedChartType,
    selectedCardType,
    questionLabels,
    surveyId,
    analyzeId,
    customerId,
    idPerguntaCruzada,
    idAlternativaCruzada
  } = props;

  function handleOnCancel() {
    if (onCancel) {
      onCancel();
    }
  }

  return (
    <CardExporting
      onCancel={handleOnCancel}
      title={title}
      types={types}
      onTypeChange={onTypeChange}
      theme={theme}
      selectedChartType={selectedChartType}
      selectedCardType={selectedCardType}
      questionLabels={questionLabels}
      surveyId={surveyId}
      analyzeId={analyzeId}
      customerId={customerId}
      idPerguntaCruzada={idPerguntaCruzada}
      idAlternativaCruzada={idAlternativaCruzada}
    />
  );
}

ContextualPopupExporting.propTypes = propTypes;
ContextualPopupExporting.defaultProps = defaultProps;

export default ContextualPopupExporting;
